import { render, staticRenderFns } from "./PublicationCreate.vue?vue&type=template&id=58f95576&"
import script from "./PublicationCreate.vue?vue&type=script&lang=js&"
export * from "./PublicationCreate.vue?vue&type=script&lang=js&"
import style0 from "./PublicationCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports